import React, { memo } from 'react';
import styles from '../../../styles/configuration/nlpconfiguration.module.scss';
import { InputBox } from '../../FormComponent';

const ResourceSettings = memo(({ maxIterations, maxSteps, maxScenarioLength, handleInputChange }) => {
    return (
        <div className={styles.resourceSettings}>
            <div className={styles.resourceSettingsContainer}>
                <span className={styles.label}>Max Iterations</span>
                <InputBox type='number' size='small' placeholder="Enter max iterations" value={maxIterations} onChange={(e) => handleInputChange(e, 'maxIterations')}/>
            </div>
            <div className={styles.resourceSettingsContainer}>
                <span className={styles.label}>Max Scenario Length</span>
                <InputBox type='number' size='small' placeholder="Enter max scenario length in tokens" value={maxScenarioLength} onChange={(e) => handleInputChange(e, 'maxScenarioLength')}/>
            </div>
            <div className={styles.resourceSettingsContainer}>
                <span className={styles.label}>Max Steps</span>
                <InputBox type='number' size='small' placeholder="Enter max steps" value={maxSteps} onChange={(e) => handleInputChange(e, 'maxSteps')}/>
            </div>
        </div>
    );
});

ResourceSettings.displayName = 'ResourceSettings';

export default ResourceSettings;